import axiosInstance from '../plugin/axios';

interface FetchAdminNoticeParams {
  title?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface NoticeDtoRx {
  noticeId: number;
  title: string;
  createdAt: string;
  viewCount: number;
}

interface DeleteNoticeDtoTx {
  noticeId: number[]; // 회원 아이디 배열
}

interface CreateNoticeDtoTx {
  title: string;
  content: string;
}

interface DetailNoticeDto {
  noticeId: number;
  title: string;
  content: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

export const fetchAdminNoticeList = async (
  params: FetchAdminNoticeParams,
): Promise<NoticeDtoRx[]> => {
  try {
    const {
      title,
      offset = 0,
      limit = 10000,
      sortBy = 'createdAt',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<NoticeDtoRx[]>(
      `/api/admin/notice`,
      {
        params: {
          title,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminDeleteNotice = async (
  data: DeleteNoticeDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.delete<ServerResponse>(
      `/api/admin/notice`,
      {
        data: data,
      },
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminRegistNotice = async (
  data: CreateNoticeDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/admin/notice`,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminUpdateNotice = async (
  noticeId: number,
  data: CreateNoticeDtoTx,
) => {
  try {
    const response = await axiosInstance.put(
      `/api/admin/notice/${noticeId}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchAdminNoticeData = async (
  noticeId: number,
): Promise<DetailNoticeDto> => {
  try {
    const response = await axiosInstance.get<DetailNoticeDto>(
      `/api/admin/notice/${noticeId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminNoticeUpdate = async (
  noticeId: number,
  data: CreateNoticeDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/admin/notice/${noticeId}`,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};
